import * as React from 'react';
import { Link } from 'react-router-dom';
import { SiteInfo } from '../../hooks/useSiteInfo';
import { NavLink } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import driverInfoSecurity from '../../utils/DriverInfoSecurity';
import Chip from '@mui/material/Chip';
import { isRecentlyUpdated } from '../../constants/recentlyUpdated';
import * as i18next from 'i18next';

interface IProps {
    site: SiteInfo;
    searchQuery?: string;
    fromAdmin: boolean;
    includeState: boolean;
}

class SiteInfoClass extends React.Component<IProps, {}>{
    constructor(props: IProps) {
        super(props);
    }

    render() {
        let style = {
            siteDetail: {
                marginLeft: 15
            } as React.CSSProperties,
            postalCode: {
                marginRight: 10
            } as React.CSSProperties,
            streetName: {
                marginBottom: 5,
                whiteSpace: "nowrap"
            } as React.CSSProperties
        };

        let isAdmin = driverInfoSecurity.isAdmin();

        return <div style={{ display: "flex", position: "relative" }}>
            <div>
                <img src={new URL("../../img/building.png", import.meta.url).href} />
            </div>
            <div style={style.siteDetail}>
                <h3>{this.props.searchQuery ? this.getHighlightedText(this.props.site.siteName, this.props.searchQuery) : this.props.site.siteName}</h3>
                <div style={style.streetName}>
                    {this.props.searchQuery ? this.getHighlightedText(this.props.site.streetAddress, this.props.searchQuery) :
                        <span>{this.props.site.streetAddress}</span>
                    }
                </div>
                <div style={{ whiteSpace: "nowrap" }}>
                    <span style={style.postalCode}>{this.props.site.postalCode}</span>
                    {this.props.searchQuery ?
                        this.getHighlightedText(this.props.site.town, this.props.searchQuery) :
                        <span>{this.props.site.town}</span>}
                </div>
            </div>
            {this.props.fromAdmin ?
                <div style={{ position: "absolute", right: 0, top: 0, zIndex: 100 }}>
                    <Link to={'/administrationsiteinfo/' + this.props.site.uniqueSiteId}>
                        <img src={new URL("../../img/edit.png", import.meta.url).href} />
                    </Link>
                </div> : null
            }
            {isAdmin && this.props.includeState ?
                <div style={{ position: "absolute", right: 0, bottom: 0 }}>
                    <span>[{this.props.site.published ? i18next.t("site.published") : i18next.t("site.draft")}]</span>
                </div> : null
            }
        </div>;
    }

    getHighlightedText(text: string, highlight: string) {
        let highLightParts = highlight.split(" ");

        return <Highlighter searchWords={highLightParts} textToHighlight={text} autoEscape={true} highlightClassName="textHighlighter" />
    }
}

export default SiteInfoClass;
